import { Typography } from '@hulu/react-style-components';
import styled from 'styled-components';

import { BlueButton } from '../../BlueTheme';

export const Wrapper = styled.div<{ withTopPadding?: boolean }>`
  display: flex;
  flex-direction: column;
  padding: ${({ theme, withTopPadding = true }): string => {
    const { spacer06 } = theme.spacers!;

    return `${+withTopPadding && spacer06} 0 ${spacer06} 0`;
  }};
  background-color: ${({ theme }): string => theme.admanColors!.gray.light.fg[6]};
`;

export const StyledTitleWrapper = styled.div`
  display: flex;
  justify-content: space-between;

  > div {
    display: flex;
  }
`;

export const StyledButtonWrapper = styled.div`
  button {
    padding: ${({ theme }): string => `${theme.spacers!.spacer04} ${theme.spacers!.spacer05}`};

    &:disabled {
      pointer-events: all;
    }
  }
`;

export const StyledDescription = styled(Typography).attrs({ variant: 'body1' })`
  padding-top: ${({ theme }): string => theme.spacers!.spacer05};
`;

export const StyledBlueButton = styled(BlueButton)`
  height: 48px;

  &:disabled {
    &:hover {
      background: ${({ theme }): string => theme.admanColors!.gray.light.bg3[5]};
    }
  }
`;
